import axios from '@/axios/'

// 譲渡/分配関連処理
const actions = {
  // 譲渡/分配開始登録
  setTktDistributeStart(_, param){
    return axios.post('/SetTktDistributeStart/1.0/', param)
  },
  // 譲渡/分配取消
  setTktDistributeCancel(_, param){
    return axios.post('/SetTktDistributeCancel/1.0/', param)
  }
}

export default {
  namespaced: true,
  actions,
}
